import React, { PropsWithChildren } from 'react'

import { useDispatch } from 'react-redux'

import { trackEvent } from '@store/analytics'

export interface IBaseRouteProps {
  eventTrigger?: 'click' | 'change' | 'mouseEnter'
  eventName: string
  inline?: boolean
  targetLink?: boolean
  disableTracking?: boolean
}

const EVENT_TRIGGER_MAP = {
  click: 'onClick',
  change: 'onChange',
  mouseEnter: 'onMouseEnter',
}

export interface ITrackedRoute extends IBaseRouteProps {
  properties: object
}

export const TrackedRoute: React.FC<PropsWithChildren<ITrackedRoute>> = ({
  eventTrigger = 'click',
  eventName,
  properties,
  targetLink,
  inline,
  children,
  disableTracking,
}) => {
  const dispatch = useDispatch()
  const trackEventAction = (name: string, eventProps: object) => dispatch(trackEvent(name, eventProps))

  const callback = (event: React.SyntheticEvent) => {
    if (disableTracking) {
      return
    }
    if (targetLink) {
      const element = event.target as HTMLElement
      if (element.nodeName.toUpperCase() === 'A') {
        trackEventAction(eventName, properties)
      }
    } else {
      trackEventAction(eventName, properties)
    }
  }

  const Wrapper = inline ? 'span' : 'div'
  const eventType = EVENT_TRIGGER_MAP[eventTrigger]
  const eventListener = { [eventType]: callback }

  return (
    <Wrapper {...eventListener} role="button" data-event-name={eventName}>
      {children}
    </Wrapper>
  )
}

export default TrackedRoute
